import { Outlet } from "react-router-dom";
const International = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default International;
